var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowLeftAlternative = function SvgArrowLeftAlternative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.731 9.188h.038H6.307l5.791-5.572c.228-.216.36-.522.36-.846 0-.324-.132-.612-.36-.846l-.738-.702a1.295 1.295 0 0 0-.89-.342c-.341 0-.644.126-.89.342L.36 10.034c-.227.216-.36.522-.36.846 0 .324.133.612.36.846l9.22 8.812c.227.216.549.342.89.342.34 0 .644-.126.89-.342l.739-.702c.227-.216.36-.522.36-.846 0-.324-.133-.594-.36-.828l-5.849-5.59h14.481c.682 0 1.269-.558 1.269-1.224V10.34c0-.63-.587-1.152-1.269-1.152Z"
  })));
};

export default SvgArrowLeftAlternative;